import type { PropertiesNullable } from '@@types/helpers'
import { SmtpEncryption } from '@app/stores/Management/StoreApplicationSettings/types'
import type {
  ApplicationSettings,
  Maybe,
  SmtpAuthenticationMethod
} from '@server/graphql/typeDefs/types'
import EntityBase from './EntityBase'

export default class EntityApplicationSettings
  extends EntityBase
  implements PropertiesNullable<ApplicationSettings>
{
  userRegistration: Maybe<boolean> = null
  activityLogsIsActive: Maybe<boolean> = null
  activityLogsRetentionDurationInMonth: Maybe<number> = null
  tls: Maybe<boolean> = null
  defaultProfileId: Maybe<number> = null
  defaultRoleIds: Maybe<number[]> = null
  internalCertificate: Maybe<string> = null
  telemetryEnabled: Maybe<boolean> = null
  ioaAutomaticConfiguration: Maybe<boolean> = null
  smtpRelayId: Maybe<number> = null
  smtpRelayUuid: Maybe<string> = null
  cloudStatisticsIsActive: Maybe<boolean> = null
  healthCheckGlobalStatusDisplayEnabled: Maybe<boolean> = null

  /** Basic SMTP configuration */
  smtpServerAddress: Maybe<string> = null
  smtpServerPort: Maybe<number> = null
  smtpAccount: Maybe<string> = null
  smtpAccountPassword: Maybe<string> = null
  smtpIsAccountPasswordDefined: Maybe<boolean> = null
  smtpUseStartTLS: Maybe<boolean> = null
  emailSender: Maybe<string> = null

  /** Office365 OAuth configuration */
  smtpAuthenticationMethod?: Maybe<SmtpAuthenticationMethod> = null
  smtpOffice365TenantId?: Maybe<string> = null
  smtpOffice365ClientId?: Maybe<string> = null
  smtpOffice365Secret?: Maybe<string> = null
  smtpIsOffice365SecretDefined?: Maybe<boolean> = null
  smtpOffice365SenderEmail?: Maybe<string> = null
  smtpOffice365SenderName?: Maybe<string> = null

  constructor(data: Partial<ApplicationSettings>) {
    super()
    Object.assign(this, data)
  }

  get smtpEncryption(): SmtpEncryption {
    if (this.tls) {
      return SmtpEncryption.tls
    }

    if (this.smtpUseStartTLS) {
      return SmtpEncryption.startTls
    }

    return SmtpEncryption.none
  }
}
